function addGclid() {
  var gclidFormFields = ["event_booking_gclid", "issue_gclid"]; // all possible gclid form field ids here
  var currGclidFormField;

  gclidFormFields.forEach(function (field) {
    if (document.getElementById(field)) {
      currGclidFormField = document.getElementById(field);
    }
  });

  var gclid = window.gclid;

  if (currGclidFormField && gclid) {
    currGclidFormField.value = gclid;
  }
}

document.addEventListener("turbo:load", addGclid);